module.exports = __webpack_public_path__ + "d92ff13116d157d490eafaed0e33a3e3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/quarantaene2.jpg
// module id = 637
// module chunks = 0